<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">          
            <div class="col-md-6">
                <div class="service">
                    <h2>
                     لماذا التسويق الالكتروني من Codesroots ؟
                    </h2>
                    <ul class="fa-ul text-right" style="padding-right: 25px;">
                        <li>                      
                            دراسة المنتج او الخدمة جيدا، وايجاد السوق المناسب للجمهور المستهدف لظهور الاعلان
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            تحديد الوقت الأنسب الاعلان والشكل المناسب للاعلان
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            تقديم احصائيات وتقارير دورية عن نشاط حملتك على الانترنت
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            تحديد الميزانية الافضل للاعلان وادارة التسعيرة للنقرات بذكاء
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li> 
                        <li>                      
                            ختيار المواقع التي سيظهر فيها اعلانك بعناية ودراسة لتضمن زوار مستهدفين
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            وضع خطة للاعلان واختيار افضل الكلمات المفتاحية لاعلانك على جوجل والجمهور المستهدف في اعلانات الفيس بوك
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>                                                                                                                        
                    </ul>                    
                </div>
            </div>
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/why-marketing.png" alt="seo" />
            </div>              
        </div>
    </div>
</section>